export default __webpack_public_path__ + "static/media/modal-image-email-confirmed.1e0a7703.webp";